export default __webpack_public_path__ + "static/media/shopping_cart.acb74224.svg";